<template>
  <sidebar-right
    @overlayClicked="outside"
    :class="[
      'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--720',
      { open: show }
    ]"
  >
  <div class="bg-white md__card--holder">
    <div class="card">
      <!-- Card header -->
      <div class="card-header" :class="{
            'blue-class': $route.name == 'projects',
            'green-class': $route.name == 'tasks.home',
            'yellow-class': $route.name == 'timesheet.home'
          }">
        <!-- Title -->
        <h4 class="h3 mb-0">{{ editTitle }}</h4>
      </div>
      <!-- Card Body -->
      <div class="card-body">
        <form class="hideBlockParent">
          <div class="form-group mb-4">
            <label>Name</label>
            <input
              id="exampleFormControlInput1"
              type="text"
              class="form-control"
              v-model="task.name"
              placeholder="Requirement Name"
            />
          </div>
          <div class="form-group mb-4">
            <label>Description</label>
            <html-editor v-model="task.description" />
          </div>


          <base-button
            type="primary"
            class="my-4 btn-block"
            @click="handleSubmit"
            >{{ editId && editId != undefined ? "Update"+editId : "Create" }}</base-button
          >
        </form>
      </div>
    </div>
  </div>
</sidebar-right>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { required, minLength, between, email } from "vuelidate/lib/validators";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import UserPicker from "@/app/components/UserPicker.vue";
import SidebarRight from "../layout/SidebarRight.vue";
export default {
  name: "CreateAssetTask",
  props: ["editId", "show", "fullWidth", "project"],
  data() {
    return {
      task: {
        asset_users: []
      },
      
      
      editTitle: "New Requirement"
    };
  },
  components: {
    HtmlEditor,
    flatPicker,
    UserPicker,
    SidebarRight
  },
  validations: {
    projectTitle: {
      required,
      minLength: minLength(4)
    },
    projectType: {
      required
    },
    client: {
      required
    }
  },

  watch: {
    editId(newVal, oldVal) {
      console.log(oldVal, newVal, "9++++++++++");
      let role = this.roles.filter(r => r.name == "CREATOR")[0];
      let assigner = { ...this.profile };
      let assignee = { ...this.project.user_owner.user };
      let roleAssignee = this.roles.filter(r => r.name == "ASSIGNEE")[0];
      if (newVal != oldVal) {
        if (newVal) {
          this.editTitle = "Edit Task";
          this.fetchTask(newVal);
        } else {
          this.task = {assignedBy: { user: assigner, asset_role: role }, assignedTo: {user: assignee, role: roleAssignee }};
          console.log("tassssssk", this.task)
          this.editTitle = "New Requirement";
        }
      } else { 
        this.task = {assignedBy: { user: assigner, asset_role: role }, assignedTo: {user: assignee, role: roleAssignee }};
        console.log("tassssssksss", this.task)
        this.editTitle = "New Requirement";
      }
    }
  },

  computed: {
    ...mapState("user", ["profile"]),
    ...mapState("common", ["roles", "resources"])
  },

  async mounted() {
    console.log("mounted+++++++");
    // console.log(this.$router, this.$route, "ddddd")
    $('[data-toggle="tooltip"]').tooltipster({
      theme: "tooltipster-borderless"
    });
    await this.fetchRoles();
    await this.fetchResources()
    if (!this.editId) {
      //this.editTitle = "New Task";
      let role = this.roles.filter(r => r.name == "CREATOR")[0];
      let owner = { ...this.profile };

      let assignee = { ...this.project.user_owner.user };
      let roleAssignee = this.roles.filter(r => r.name == "ASSIGNEE")[0];

      this.task = {
        assignedBy: { user: owner, asset_role: role },
        assignedTo: {user: assignee, asset_role: roleAssignee}
      };
    } else {
      //this.editTitle = "Edit Task";
      this.fetchTask(this.editId);
    }
  },

  methods: {
    ...mapActions("user", ["fetchAllUsers"]),
    ...mapActions("task", ["fetchSingleTask", "createTask", "updateTask"]),
    ...mapActions("common", ["fetchRoles", "fetchResources"]),
    ...mapMutations(["setGanttRender"]),
    onResourceChanged() {
      this.task.hourly_cost = this.task.resource.hourly_cost;
    },
    async fetchTask(val) {
      try {
        const res = await this.fetchSingleTask(val);
        this.task = res.data || {};
      } catch (e) {
        this.task= {}
        this.$snack.success("Could not fetch task");
      }
    },

    outside() {
      this.$emit("outSideClicked");
    },

    handleSubmit() {
      console.log("task to be created ", this.task, this.$route)
      if (this.task.name == null || this.task.name == "") {
        this.$snack.success("Task title is required");
        return;
      }

      if (this.task.description == null || this.task.description == "") {
        this.$snack.success("Description is required");
        return;
      }

      if (!this.task.assignedBy) {
        this.$snack.success("Task Assigned By is required");
        return;
      }

      if (!this.task.assignedTo) {
        this.$snack.success("Task Assigned to is required");
        return;
      }

      // add task by and task to validations

      // if (this.task.months == null || this.task.months == "") {
      //   this.$snack.success("Months is required");
      //   return;
      // }

      // if (this.task.deadline == null || this.task.deadline == "") {
      //   this.$snack.success("Deadline is required");
      //   return;
      // }

      // if (this.task.resource) {
      //   if (this.task.hourly_cost == null || this.task.hourly_cost == "") {
      //     this.$snack.success("Please enter total rate");
      //     return;
      //   }

      //   if (this.task.quoted_hours == null || this.task.quoted_hours == "") {
      //     this.$snack.success("Please enter total hours");
      //     return;
      //   }
      // } else {
      //   this.$snack.success("Select price resource");
      // }

      let body = {
        ...this.task,
        parent_id: this.$route.params.id,
        approval_status:'DRAFT'
      };

      if (this.editId != undefined) {
        body.id = this.editId;
        this.updateTask(body)
          .then(res => {
            this.setGanttRender();
            this.$snack.success("Requirement Updated Successfully");
            this.$emit("taskCreated");
            this.selectedUser = null;
          })
          .catch(er => {
            this.$snack.success("Could not create project");
          });
      } else {
        this.createTask(body)
          .then(res => {
            this.setGanttRender();
            this.$snack.success("Requirement Created Successfully");
            this.$emit("taskCreated");
            this.selectedUser = null;
          })
          .catch(er => {
            this.$snack.success("Could not create Requirement");
          });
      }
    }
  },

 
};
</script>

<style lang="sass"></style>
